// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__ngLea","bounce":"Loader_bounce__2F28r"};